import { Link } from 'react-router-dom';

// Páginas legais (LGPD). Política de Privacidade da Momday (Jornadas
// Educação Ltda.) vinda do template fornecido em 2026-04-22.
//
// Termos de Uso: pendente. Quando receber, substituir o placeholder em
// <Terms> abaixo (mesma estrutura do <Privacy>).
//
// Por que estático no shell (e não no backend):
// - Páginas públicas, sem auth, sem dados dinâmicos
// - CF Pages cacheia sem custo
// - Um review/diff simples basta pra atualização futura

function LegalLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <div style={styles.wrap}>
      <div style={styles.container}>
        <Link to="/" style={styles.back}>
          ← Voltar
        </Link>
        <h1 style={styles.title}>{title}</h1>
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
        <div style={styles.body}>{children}</div>
      </div>
    </div>
  );
}

export function Privacy() {
  return (
    <LegalLayout
      title="Política de Privacidade"
      subtitle="Última atualização: 19 de abril de 2026"
    >
      <p>
        Esta Política de Privacidade descreve como a{' '}
        <strong>JORNADAS EDUCAÇÃO LTDA.</strong>, inscrita no CNPJ/ME sob o nº
        58.559.205/0001-91, com sede em São Paulo/SP ("Momday", "nós" ou
        "Controladora"), coleta, utiliza, armazena, compartilha e protege os
        dados pessoais dos usuários do aplicativo Momday ("Aplicativo"),
        disponibilizado como Progressive Web App (PWA).
      </p>
      <p>
        O Momday é voltado a mães, pais ou responsáveis legais. A conta é
        sempre titularizada por pessoa maior de 18 anos; os dados da criança
        são fornecidos pelo próprio responsável, nos termos do art. 14 da
        LGPD.
      </p>

      <h2>1. Definições</h2>
      <ul>
        <li><strong>Aplicativo:</strong> o Momday, PWA acessível por navegador.</li>
        <li><strong>Controladora:</strong> Jornadas Educação Ltda.</li>
        <li><strong>Operadores:</strong> terceiros que tratam dados em nome da Controladora.</li>
        <li><strong>Titular:</strong> pessoa natural a quem se referem os dados.</li>
        <li><strong>Dado Sensível:</strong> dado sobre saúde, origem racial, religião, etc.</li>
        <li><strong>Encarregado (DPO):</strong> canal de comunicação com Titulares e ANPD.</li>
      </ul>

      <h2>2. Dados que coletamos</h2>
      <p>
        <strong>2.1. Responsável legal:</strong> nome, e-mail, CPF, dificuldades
        relatadas, preferências de uso, dados de autenticação.
      </p>
      <p>
        <strong>2.2. Criança (fornecidos pelo responsável):</strong>{' '}
        nome/apelido, faixa etária (2-3, 4-5, 6-8, 9-12), restrições
        alimentares (dados sensíveis), alimentos aceitos por grupo nutricional.
      </p>
      <p>
        Não coletamos dados biométricos, geolocalização precisa, documentos,
        dados escolares ou fotos da criança.
      </p>
      <p>
        <strong>2.3. Pagamento:</strong> processado pela Asaas. Não
        armazenamos dados completos de cartão. Recebemos: status, vencimento,
        valor, ID da transação e últimos 4 dígitos. O CPF do titular é
        coletado no momento do checkout e compartilhado com a Asaas
        exclusivamente para emissão do recibo fiscal e identificação do
        assinante, conforme exigência regulatória.
      </p>
      <p>
        <strong>2.4. Dados técnicos e de uso:</strong> IP, dispositivo,
        navegador, SO, registros de acesso, ações no Aplicativo, logs de erro.
      </p>
      <p>
        <strong>2.5. NÃO coletamos:</strong> fotos da lancheira (a função
        "Celebração" gera localmente, sem envio aos servidores); dados de
        cartão em texto claro; documentos da criança; contatos, mensagens ou
        arquivos do dispositivo.
      </p>

      <h2>3. Finalidades do tratamento</h2>
      <p>
        <strong>3.1. Prestação do serviço:</strong> criar conta, gerar
        cardápios, lista de compras, filtrar receitas (incl. SOS), enviar
        lembretes, registrar histórico/conquistas.
      </p>
      <p>
        <strong>3.2. Gestão da assinatura:</strong> processar pagamentos via
        Asaas, gerenciar renovações e testes, comunicações via Resend.
      </p>
      <p>
        <strong>3.3. Suporte e melhoria:</strong> responder dúvidas, corrigir
        falhas, analisar uso agregado.
      </p>
      <p>
        <strong>3.4. Obrigações legais:</strong> registros de acesso,
        atendimento a autoridades.
      </p>

      <h2>4. Bases legais (LGPD)</h2>
      <p>
        <strong>4.1. Responsável:</strong> execução de contrato (art. 7º, V),
        obrigação legal (art. 7º, II), legítimo interesse (art. 7º, IX).
      </p>
      <p>
        <strong>4.2. Criança:</strong> consentimento específico e em destaque
        do responsável (art. 14, §1º) e execução de contrato no melhor
        interesse do menor.
      </p>
      <p>
        <strong>4.3. Sensíveis (saúde):</strong> consentimento específico e
        destacado (art. 11, I) para gerar recomendações seguras.
      </p>
      <p>
        <strong>4.4. Pagamento:</strong> execução de contrato e obrigação
        legal (fiscal/regulatória).
      </p>

      <h2>5. Compartilhamento com terceiros</h2>
      <p>
        Não vendemos dados. Compartilhamos apenas com Operadores necessários:
      </p>
      <ul>
        <li><strong>Railway</strong> — infraestrutura de back-end.</li>
        <li>
          <strong>Asaas</strong> — gateway de pagamento (Controladora
          independente quanto a dados financeiros).
        </li>
        <li><strong>Resend</strong> — e-mails transacionais.</li>
        <li>
          <strong>Cloudflare</strong> — CDN, hospedagem do front-end e
          entrega de bundles (dados técnicos e de acesso).
        </li>
        <li>
          <strong>Autoridades públicas</strong> — quando exigido por lei.
        </li>
      </ul>
      <p>
        Dados de criança nunca são compartilhados sem consentimento do
        responsável (art. 14, §3º, LGPD).
      </p>

      <h2>6. Transferência internacional</h2>
      <p>
        Railway, Resend e Cloudflare possuem infraestrutura no exterior. A
        transferência ocorre com fundamento no art. 33 da LGPD, observando
        cláusulas contratuais e garantias de segurança.
      </p>

      <h2>7. Armazenamento e retenção</h2>
      <ul>
        <li>Dados da conta: enquanto a conta estiver ativa;</li>
        <li>Dados da criança após exclusão: eliminados em até 30 dias;</li>
        <li>Registros de acesso: mínimo 6 meses (Marco Civil, art. 15);</li>
        <li>Dados fiscais: prazo legal aplicável (em geral 5 anos).</li>
      </ul>
      <p>
        Encerrados os prazos, dados são eliminados de forma segura ou
        anonimizados.
      </p>

      <h2>8. Direitos dos Titulares</h2>
      <p>Nos termos dos arts. 17 a 22 da LGPD, você pode obter:</p>
      <ul>
        <li>Confirmação da existência de tratamento;</li>
        <li>Acesso aos dados;</li>
        <li>Correção de dados incompletos ou inexatos;</li>
        <li>Anonimização, bloqueio ou eliminação;</li>
        <li>Portabilidade;</li>
        <li>Eliminação de dados tratados com consentimento;</li>
        <li>Informação sobre compartilhamentos;</li>
        <li>Revogação do consentimento (art. 8º, §5º).</li>
      </ul>
      <p>Solicitações pelo canal do DPO (Seção 10). Atendimento gratuito.</p>

      <h2>9. Segurança da informação</h2>
      <ul>
        <li>HTTPS/TLS;</li>
        <li>Provedores com padrões reconhecidos;</li>
        <li>Controle de acesso e princípio do menor privilégio;</li>
        <li>Logs de auditoria;</li>
        <li>Revisão periódica de práticas.</li>
      </ul>
      <p>
        Em caso de incidente relevante, comunicaremos a ANPD e os Titulares
        (art. 48, LGPD).
      </p>

      <h2>10. Encarregado (DPO)</h2>
      <p>
        <strong>E-mail do DPO:</strong>{' '}
        <a href="mailto:pedro.peres@grupoprisma.tech">
          pedro.peres@grupoprisma.tech
        </a>
      </p>
      <p>
        Reclamações também podem ser apresentadas à ANPD em{' '}
        <a
          href="https://www.gov.br/anpd"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.gov.br/anpd
        </a>
        .
      </p>

      <h2>11. Proteção especial de dados de crianças</h2>
      <p>
        O Momday é projetado para adultos. A criança não usa o Aplicativo
        diretamente. Em cumprimento ao art. 14 da LGPD:
      </p>
      <ul>
        <li>Coletamos apenas o estritamente necessário;</li>
        <li>Não condicionamos uso ao fornecimento excessivo de dados;</li>
        <li>Não compartilhamos dados da criança para publicidade ou perfilamento;</li>
        <li>Canal específico para o responsável exercer direitos;</li>
        <li>Exclusão imediata do perfil do filho pelas configurações.</li>
      </ul>

      <h2>12. Cookies e armazenamento local</h2>
      <p>
        Como PWA, usamos cookies, localStorage e IndexedDB apenas para:
        autenticação, funcionamento offline e preferências. Não usamos
        cookies publicitários ou de rastreamento de terceiros.
      </p>

      <h2>13. Luma — Assistente Virtual</h2>
      <p>
        A Luma apresenta mensagens roteirizadas pela equipe Momday em
        momentos-chave. Não envolve geração de texto por modelos de IA de
        terceiros, portanto não há transferência de dados a esses provedores.
        Caso isso mude, esta Política será atualizada previamente.
      </p>

      <h2>14. Alterações desta Política</h2>
      <p>
        Em caso de alterações materiais, o usuário será notificado por e-mail
        ou aviso no Aplicativo com antecedência razoável.
      </p>

      <h2>15. Lei aplicável e foro</h2>
      <p>
        Regida pela legislação brasileira (LGPD, Marco Civil, CDC, ECA). Foro:
        Comarca de São Paulo/SP, ressalvada competência dos juizados especiais
        ou foro mais favorável ao consumidor.
      </p>

      <h2>16. Contato</h2>
      <p>
        <strong>Jornadas Educação Ltda.</strong>
        <br />
        CNPJ: 58.559.205/0001-91
        <br />
        E-mail (DPO e suporte):{' '}
        <a href="mailto:pedro.peres@grupoprisma.tech">
          pedro.peres@grupoprisma.tech
        </a>
        <br />
        WhatsApp: +55 11 93621-3635
      </p>
    </LegalLayout>
  );
}

export function Terms() {
  return (
    <LegalLayout
      title="Termos de Uso"
      subtitle="Última atualização: 22 de abril de 2026"
    >
      <p>
        Estes Termos de Uso ("Termos") regem o acesso e uso do aplicativo
        Momday ("Aplicativo"), operado pela{' '}
        <strong>JORNADAS EDUCAÇÃO LTDA.</strong>, inscrita no CNPJ/ME sob o nº
        58.559.205/0001-91, com sede em São Paulo/SP ("Momday", "nós"). Ao
        criar uma conta ou utilizar o Aplicativo, você declara ter lido,
        compreendido e aceitado estes Termos, bem como a{' '}
        <Link to="/privacidade">Política de Privacidade</Link>.
      </p>

      <h2>1. Objeto</h2>
      <p>
        O Momday oferece, em formato PWA (Progressive Web App), conteúdos e
        ferramentas voltados a mães, pais ou responsáveis legais para apoio na
        alimentação infantil: cardápios, lista de compras, receitas, SOS de
        alimentação seletiva, lembretes e celebração de conquistas.
      </p>

      <h2>2. Elegibilidade e cadastro</h2>
      <p>
        <strong>2.1.</strong> A conta é titularizada por pessoa maior de 18
        anos. Você se compromete a fornecer informações verdadeiras, atuais e
        completas, e a mantê-las atualizadas.
      </p>
      <p>
        <strong>2.2.</strong> Dados da criança são fornecidos pelo responsável
        legal nos termos do art. 14 da LGPD (ver Política de Privacidade).
      </p>
      <p>
        <strong>2.3.</strong> Você é responsável pela confidencialidade de
        suas credenciais de acesso e por qualquer atividade realizada na sua
        conta.
      </p>

      <h2>3. Assinatura, pagamento e período de experiência</h2>
      <p>
        <strong>3.1. Período de experiência (trial):</strong> assinaturas
        incluem período inicial gratuito de <strong>7 (sete) dias</strong>,
        contados da ativação. Durante esse prazo, o cancelamento não gera
        cobrança.
      </p>
      <p>
        <strong>3.2. Formas de pagamento:</strong> cartão de crédito ou Pix
        Automático, processados pela <strong>Asaas</strong> (instituição de
        pagamento autorizada pelo Banco Central). Não armazenamos dados
        completos do cartão (ver Política de Privacidade §2.3).
      </p>
      <p>
        <strong>3.3. Renovação automática:</strong> após o trial, a assinatura
        renova-se automaticamente pelo ciclo escolhido (mensal ou anual) até
        que você cancele. O valor vigente é aquele exibido na tela de
        checkout no momento da contratação.
      </p>
      <p>
        <strong>3.4. Cobrança:</strong> ocorre no 1º dia do ciclo (fim do
        trial) e nas datas de renovação subsequentes. Falhas de cobrança
        podem suspender o acesso até regularização.
      </p>
      <p>
        <strong>3.5. CPF:</strong> a coleta de CPF no checkout é exigência
        regulatória do processador de pagamento, utilizada apenas para
        emissão de recibo fiscal e identificação do assinante.
      </p>

      <h2>4. Cancelamento e reembolso</h2>
      <p>
        <strong>4.1. Cancelamento:</strong> você pode cancelar a qualquer
        momento pela tela de configurações da conta ou solicitando ao
        suporte. O cancelamento é confirmado por e-mail.
      </p>
      <p>
        <strong>4.2. Efeito do cancelamento:</strong> cancelamentos durante o
        trial não geram cobrança. Após o trial, o cancelamento encerra a
        renovação no fim do ciclo pago corrente — você mantém acesso até essa
        data.
      </p>
      <p>
        <strong>4.3. Direito de arrependimento (CDC art. 49):</strong>{' '}
        contratações realizadas fora do estabelecimento comercial
        (contratação à distância pela internet) podem ser desfeitas em até{' '}
        <strong>7 (sete) dias</strong> contados da ativação, com reembolso
        integral. Solicitações por{' '}
        <a href="mailto:pedro.peres@grupoprisma.tech">
          pedro.peres@grupoprisma.tech
        </a>
        .
      </p>
      <p>
        <strong>4.4. Reembolsos fora da janela de arrependimento:</strong>{' '}
        avaliados caso a caso. Em caso de falha técnica do nosso lado,
        reembolsamos proporcionalmente ao período impactado.
      </p>

      <h2>5. Uso permitido e proibido</h2>
      <p>
        <strong>5.1. Uso permitido:</strong> pessoal e familiar. Você pode
        compartilhar conteúdos gerados (listas, cardápios) no seu círculo
        pessoal.
      </p>
      <p><strong>5.2. É proibido:</strong></p>
      <ul>
        <li>Revender, sublicenciar ou redistribuir o conteúdo do Aplicativo;</li>
        <li>
          Compartilhar credenciais de acesso com terceiros fora do núcleo
          familiar;
        </li>
        <li>
          Fazer engenharia reversa, scraping massivo, ataques automatizados
          ou qualquer tentativa de comprometer a segurança do Aplicativo;
        </li>
        <li>Utilizar o Aplicativo para fins ilícitos ou contrários à moral;</li>
        <li>Fornecer informações falsas ou de terceiros sem autorização.</li>
      </ul>
      <p>
        <strong>5.3.</strong> Violações podem resultar em suspensão ou
        encerramento da conta, sem reembolso proporcional, sem prejuízo das
        medidas legais cabíveis.
      </p>

      <h2>6. Natureza do conteúdo — aviso importante</h2>
      <p>
        O conteúdo do Momday tem caráter <strong>informativo e educacional</strong>{' '}
        e <strong>não substitui aconselhamento profissional</strong> (pediatra,
        nutricionista, fonoaudiólogo, terapeuta ocupacional). Em caso de
        restrições alimentares, alergias, intolerâncias ou condições de
        saúde, consulte profissional habilitado antes de aplicar
        recomendações.
      </p>

      <h2>7. Propriedade intelectual</h2>
      <p>
        Todos os conteúdos, marcas, logos, layouts, ilustrações, textos,
        receitas e software do Aplicativo são de titularidade da Jornadas
        Educação Ltda. ou de seus licenciantes e são protegidos por lei. O
        acesso ao Aplicativo concede licença limitada, pessoal, não exclusiva
        e não transferível de uso, restrita à vigência da assinatura.
      </p>

      <h2>8. Disponibilidade e melhor esforço</h2>
      <p>
        <strong>8.1.</strong> Envidamos melhores esforços para manter o
        Aplicativo disponível, mas não oferecemos SLA contratual. Podem
        ocorrer indisponibilidades para manutenção, atualizações, falhas de
        terceiros (provedor de hospedagem, gateway de pagamento) ou eventos
        de força maior.
      </p>
      <p>
        <strong>8.2.</strong> Reservamo-nos o direito de modificar, suspender
        ou descontinuar funcionalidades, sempre com comunicação prévia
        razoável quando se tratar de mudanças materiais.
      </p>

      <h2>9. Limitação de responsabilidade</h2>
      <p>
        <strong>9.1.</strong> Respondemos nos limites da legislação brasileira
        aplicável (CDC, Código Civil).
      </p>
      <p>
        <strong>9.2.</strong> Não nos responsabilizamos por danos decorrentes
        de: (i) uso indevido do Aplicativo; (ii) decisões do usuário tomadas
        com base em conteúdo informativo sem consulta a profissional
        habilitado; (iii) falhas de conectividade do usuário; (iv) caso
        fortuito, força maior ou atos de terceiros.
      </p>
      <p>
        <strong>9.3.</strong> Nos casos em que a responsabilidade for
        reconhecida judicialmente, fica limitada ao valor efetivamente pago
        pelo usuário nos 12 (doze) meses anteriores ao evento danoso,
        salvo disposição legal cogente em contrário.
      </p>

      <h2>10. Suporte</h2>
      <p>
        Suporte via e-mail{' '}
        <a href="mailto:pedro.peres@grupoprisma.tech">
          pedro.peres@grupoprisma.tech
        </a>{' '}
        ou WhatsApp +55 11 93621-3635, em horário comercial. Melhores
        esforços para resposta em até 48 horas úteis.
      </p>

      <h2>11. Alterações destes Termos</h2>
      <p>
        Podemos alterar estes Termos a qualquer momento. Alterações materiais
        serão comunicadas por e-mail ou aviso no Aplicativo com antecedência
        razoável. O uso continuado após a data de vigência implica aceite
        das novas condições. Se você não concordar, poderá cancelar a
        assinatura.
      </p>

      <h2>12. Lei aplicável e foro</h2>
      <p>
        Estes Termos são regidos pela legislação brasileira (notadamente CDC,
        LGPD, Marco Civil da Internet e Código Civil). Fica eleito o foro da
        <strong> Comarca de São Paulo/SP</strong>, ressalvada competência dos
        juizados especiais e foro mais favorável ao consumidor, quando
        aplicável.
      </p>

      <h2>13. Contato</h2>
      <p>
        <strong>Jornadas Educação Ltda.</strong>
        <br />
        CNPJ: 58.559.205/0001-91
        <br />
        E-mail (DPO e suporte):{' '}
        <a href="mailto:pedro.peres@grupoprisma.tech">
          pedro.peres@grupoprisma.tech
        </a>
        <br />
        WhatsApp: +55 11 93621-3635
      </p>
    </LegalLayout>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    minHeight: '100vh',
    background: '#fafafa',
    padding: '48px 16px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: '#1a1a1a',
  },
  container: {
    maxWidth: 720,
    margin: '0 auto',
    background: '#fff',
    padding: '32px 40px',
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  },
  back: {
    color: '#666',
    textDecoration: 'none',
    fontSize: 14,
  },
  title: {
    marginTop: 16,
    marginBottom: 8,
    fontSize: 28,
    fontWeight: 600,
  },
  subtitle: {
    marginTop: 0,
    marginBottom: 32,
    fontSize: 14,
    color: '#888',
  },
  body: {
    fontSize: 15,
    lineHeight: 1.7,
    color: '#333',
  },
  pending: {
    padding: 16,
    background: '#fff7e6',
    border: '1px solid #ffe0a3',
    borderRadius: 8,
    fontSize: 15,
    lineHeight: 1.6,
  },
};
